// import { useContext, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { CrisisContext, SurveyTriggerContext } from "../../App";
// import { Grid } from "@trussworks/react-uswds";
// import { Link, useLocation } from "react-router-dom";
// import { isMobile } from "react-device-detect";

// const DESKTOP_CLASSES = "border-bottom border-base-lighter result-card-inactive";
// const MOBILE_CLASSES = "border border-base-lighter radius-lg padding-2 margin-bottom-1";

export const CrisisMessage = () => {
  
  // const { t } = useTranslation();
  // const location = useLocation();
  // const { crisisSelectedValues } = useContext(CrisisContext);
  // const { incrementTriggerEventCount } = useContext(SurveyTriggerContext);

  // const [enterCard, setEnterCard] = useState(false);
  
  return (
    // location.search &&
    // crisisSelectedValues.length > 0 &&
    // location.search.includes("page=1") // only in page 1
    // ? 
    // <div 
    //     className={
    //       isMobile
    //         ? MOBILE_CLASSES
    //         : DESKTOP_CLASSES
    //     }
    //     key='988-line'
    //   >
    //   <div className={enterCard ? "padding-y-1 padding-x-5 result-card-hover" : "padding-y-1 padding-x-5 result-card-not-active"}
    //     role='presentation'
    //     onMouseEnter={() => {setEnterCard(true) }}
    //     onMouseLeave={() => {setEnterCard(false) }}
    //     // Only set id in the desktop list to avoid creating
    //     // duplicate DOM elements with same id in mobile list
    //     id={isMobile ? undefined : "988-line"}
    //   >
    //     <Grid 
    //       row
    //       style={{gap: '1px'}}
    //       mobile={{ col: true }}
    //     >
    //       <div className="display-flex flex-justify" >
    //         <div className="search-rank" >
    //           <span >
    //             <img src={require("../../images/phone.png")} alt="" />
    //           </span>
    //         </div>
    //         <Link
    //           onClick={incrementTriggerEventCount}
    //           className="usa-link"
    //           to='/result/988-line'
    //           state={{ prevSearch: location.search,  }}
    //           >
    //           <h2 className=" margin-top-1 margin-bottom-1" style={{marginLeft: 13}} >{t("988-line")}</h2>
    //         </Link>
    //         </div>
    //     </Grid>
    //     <div className="display-flex flex-justify" style={{ marginLeft: "60px"}} >
    //         {t("988-line-description")}
    //     </div>
    //   </div>
    // </div>
    // :
    <></>
  );
};